import { Controller } from "@hotwired/stimulus"

// Mutually exclusive subject pickers on the deck metadata form (ADR-0069).
// A deck's reportable is EITHER a Mission OR a ClientCycle, never both. The
// record only ever holds one polymorphic reportable, so this is UX-only: when
// the operator picks a non-blank value in one select, blank the other so the
// form never posts both subject ids.
//
// Both selects are Slim Select instances. Slim hides the native <select> and
// renders its own UI, so setting `.value` directly would leave Slim's chip
// stale — the clear must go through the other element's slim controller. Slim
// fires a native `change` on the underlying select when it clears, but the
// cleared value is "" so exclusive() early-returns — no infinite loop.
export default class extends Controller {
  static targets = ["mission", "clientCycle"]

  exclusive(event) {
    if (event.target.value === "") return

    const other = event.target === this.missionTarget
      ? this.clientCycleTarget
      : this.missionTarget
    const slim = this.application.getControllerForElementAndIdentifier(other, "slim")
    if (slim) slim.clear()
    else other.value = ""
  }
}
